import { z } from "zod";

import { LIMITS, SEARCH_PROVIDER_KINDS, SYSTEM_FOLDERS } from "../constants.js";
import {
  booleanQuerySchema,
  emailAddressSchema,
  labelIdSchema,
  listQuerySchema,
} from "./common.js";
import { messageSummarySchema } from "./message.js";

export const searchProviderKindSchema = z.enum([...SEARCH_PROVIDER_KINDS]);

/** Which fields a query is matched against. */
export const SEARCH_SCOPES = ["all", "subject", "from", "to", "body"] as const;
export type SearchScope = (typeof SEARCH_SCOPES)[number];

export const searchQuerySchema = listQuerySchema.extend({
  q: z.string().min(1).max(LIMITS.maxSearchQueryLength),
  scope: z.enum([...SEARCH_SCOPES]).default("all"),
  folder: z.enum([...SYSTEM_FOLDERS]).optional(),
  labelId: labelIdSchema.optional(),
  from: emailAddressSchema.optional(),
  to: emailAddressSchema.optional(),
  before: z.string().optional(),
  after: z.string().optional(),
  isUnread: booleanQuerySchema.optional(),
  hasAttachment: booleanQuerySchema.optional(),
});
export type SearchQuery = z.infer<typeof searchQuerySchema>;

export const searchResultSchema = z.object({
  messages: z.array(messageSummarySchema),
  pageInfo: z.object({
    limit: z.number().int().positive(),
    nextCursor: z.string().nullable(),
    hasMore: z.boolean(),
  }),
  tookMs: z.number().nonnegative(),
  provider: searchProviderKindSchema,
});
export type SearchResult = z.infer<typeof searchResultSchema>;
